<template>
	<v-autocomplete
		v-model="place"
		:items="items"
		:item-text="text"
		:item-value="value"
		dense
		outlined
		filled
		clearable
		label="Seleccione un establecimiento"
		no-data-text="No hay establecimientos"
		@change="setPlace"
	/>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { capitalize } from 'lodash';

export default {
	props: {
		id: {
			type: String,
			default: '',
		},
		setPlace: {
			type: Function,
			required: true,
		},
		selected: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			place: null,
			loading: false,
		};
	},
	computed: {
		...mapGetters({
			items: 'Place/placesUser',
			message: 'Place/message',
		}),
	},
	watch: {
		id() {
			this.getPlaces();
		},
		selected(newVal) {
			if (newVal !== 1) {
				this.place = null;
			}
		},
	},
	mounted() {
		if (this.id) {
			this.getPlaces();
		}
	},
	methods: {
		getPlaces() {
			this.loading = true;
			this.fetchPlacesByIdUser(this.id)
				.then(() => (this.loading = false))
				.catch(() => (this.loading = false));
		},
		text(text) {
			const name = capitalize(text.name);
			return `${name}`;
		},
		value(text) {
			return text;
		},
		...mapActions({
			fetchPlacesByIdUser: 'Place/fetchPlacesByIdUser',
		}),
	},
};
</script>
